import * as React from 'react'
import { Link } from 'gatsby'
import o2FooterImage from "../images/O2Logos/Dark/O2FooterLogo.png"
import { UseSiteLinks } from '../hooks/use-site-links'
import { UseSocialLinks } from '../hooks/use-social-links'
import { CookieNotice } from "gatsby-cookie-notice";
import PrivacyPolicyLink from './privacyPolicy'
import CorporateComplianceLink from './corporateCompliance'
const Footer = () => {
    const { edge_Cloud_Link,
        edge_Specialist_Link,
        edge_Animations_Link,
        edge_Imaging_Link,
        vP_To_Edge_Cloud_Link,
        established_Practice_Link,
        new_Startup_Link,
        pediatric_Dentistry_Link,
        dSO_Link,
        uGM_Link,
        cEWS_Link,
        blog_Link,
        newsletters_Link,
        company_History_Link,
        careers_Link,
        meet_The_Team_Link,
        referral_Rewards_Link,
        lunch_And_Learn_Link,
        regional_Managers_Link,
        preferences,
        privacy_Policy,
        corporate_Compliance,
    } = UseSiteLinks()
    const {
        fB_Link,
        youTube_Link,
        twitter_Link,
        linkedIn_Link,
        instagram_Link,
    } = UseSocialLinks()

    return (
        <>
    <footer className="footer">
    <div className="container pb-3">
        <div className="row">
            <div className="col-6 col-md-4 col-lg-2">
                <h6>Our Solutions</h6>
                <Link href={edge_Cloud_Link}>
                    Edge Cloud
                </Link><br />
                <Link href={edge_Animations_Link}>
                    Edge Animations
                </Link><br />
                <Link href={edge_Imaging_Link}>
                    Edge Imaging
                </Link><br />
                <Link href={edge_Specialist_Link}>
                    Edge Specialist
                </Link><br />
                <Link href={vP_To_Edge_Cloud_Link}>
                    ViewPoint to Edge Cloud
                </Link>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
                <h6 className="mt-lg-0">Your Needs</h6>
                <Link className="text-nowrap" href={established_Practice_Link}>
                    Established Practices
                </Link><br />
                <Link href={new_Startup_Link}>
                    New Startup
                </Link><br />
                <Link href={pediatric_Dentistry_Link}>
                    Pediatric Dentistry
                </Link><br />
                <Link href={dSO_Link} className="text-nowrap">
                    Dental Service Organization
                </Link>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
                <h6 className="mt-3 mt-md-0">Resources</h6>
                <Link href={uGM_Link}>
                    Users Group Meeting
                </Link><br />
                <Link href={cEWS_Link} className="text-nowrap">
                    Cutting Edge Webinar Series
                </Link><br />
                <Link href={blog_Link}>
                    Blog
                </Link><br />
                <Link href={newsletters_Link}>
                    Newsletters
                </Link>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
                <h6 className="mt-3 mt-lg-0">About Us</h6>
                <Link href={company_History_Link}>
                    Company History
                </Link><br />
                <Link href={careers_Link}>
                    Careers
                </Link><br />
                <Link href={meet_The_Team_Link}>
                    Meet the Team
                </Link>
            </div>
            <div className="col-6 col-lg-2">
                <h6 className="text-nowrap mt-3 mt-md-0">Let Us Help You</h6>
                <Link href={regional_Managers_Link}>
                    Your Regional Manager
                </Link><br />
                <Link href={lunch_And_Learn_Link}>
                    Request a Lunch and Learn
                </Link><br />
                <Link href={referral_Rewards_Link}>
                    Referral Rewards
                </Link>
            </div>
            <div className="col-6 col-lg-2 pt-0 pt-md-2">
                <img src={o2FooterImage} alt="Ortho2" title="Ortho2" width="150px" height="36px" /><br />
            </div>
        </div>
    </div>
    <div className="lower-footer text-center">
        <div className="d-flex justify-content-center mb-2">
            <a href={fB_Link} target="_blank" rel="noreferrer" className="mx-2">
                <i className="fa fa-brands fa-facebook-f"></i>
            </a>
            <a href={youTube_Link} target="_blank" rel="noreferrer" className="mx-2">
                <i className="fa fa-brands fa-youtube"></i>
            </a>
            <a href={twitter_Link} target="_blank" rel="noreferrer" className="mx-2">
                <i className="fa fa-brands fa-x-twitter"></i>
            </a>
            <a href={linkedIn_Link} target="_blank" rel="noreferrer" className="mx-2">
                <i className="fa fa-brands fa-linkedin"></i>
            </a>
            <a href={instagram_Link} target="_blank" rel="noreferrer" className="mx-2">
                <i className="fa fa-brands fa-instagram"></i>
            </a>
        </div>
        Ortho2, &copy; 2025 | 1107 Buckeye Avenue | Ames, Iowa 50010 | Sales: <a href="tel:+8006784644">800.678.4644</a> | Email: <a href="mailto:sales@ortho2.com">sales@ortho2.com</a> | <PrivacyPolicyLink></PrivacyPolicyLink> | <CorporateComplianceLink></CorporateComplianceLink> | <Link href={ preferences }>Preferences</Link>
    </div>
    </footer>
    <CookieNotice
        backgroundClasses={"cookieBox p-4"}
        cookieDays={365}
        personalizeButtonEnable={true}
        personalizeButtonClasses={"btn btn-sm btn-BrandingBlueBackground mr-2"}
        personalizeButtonText={"Personalize"}
        personalizeValidationClasses={"btn btn-sm btn-BrandingBlueBackground"}
        acceptButtonClasses={"btn btn-sm btn-BrandingBlueBackground"}
        declineButton={true}
        cookieTitleClasses={"cookieTitle"}
        declineButtonClasses={"btn btn-sm btn-BrandingBlueBackground mr-2"}
        declineButtonText={"Decline"}
        wrapperClasses={"d-flex cookie-notice float-right cookieBtnMargin"}
        cookies={[
                {name: 'o2PrivacyPolicy', editable: false, default: true, title: 'Essential', text: 'These cookies are necessary to provide you with services and features available through the website.' },
                {name: 'gatsby-gdpr-google-analytics', editable: true, default: true, title: 'Google Analytics', text: 'Google Analytics is a statistical tool of Google allowing Ortho2 to measure the audience of the website.' }
        ]}>
        <p><span className="font-weight-bold">This website uses cookies.</span> This site uses cookies to analyze traffic, remember your preferences, and optimize your experience.</p>
      </CookieNotice>
    </>
    )
}

export default Footer